import { useTranslation } from 'react-i18next'

import { ActionSelect } from '../../../../Action'
import { getEntityTabEmailsMessageModalActions } from '../../EntityTabEmails.utils'

function EntityTabEmailsMessageModalActions({ data, onClickAction }) {
  const { t } = useTranslation()

  return (
    <ActionSelect
      actions={getEntityTabEmailsMessageModalActions({ item: data, t })}
      onClickAction={onClickAction}
    />
  )
}

export default EntityTabEmailsMessageModalActions
